<template lang="pug">
    v-list(dense style="width:220px; float:right;")
        v-list-item
            v-icon(left) mdi-account-outline
            v-list-item-title {{this.user.email}}
        v-divider
        v-list-item(@click="settings()")
            v-icon(left) mdi-settings
            v-list-item-title {{ $t('User_settings') }}
        //- v-list-item(@click="account()")
            v-icon(left) mdi-account-box-outline
            v-list-item-title Account
        v-list-item(@click="goToHelp()")
            v-icon(left) mdi-help-circle-outline
            v-list-item-title {{ $t('Help') }}
            //v-icon(left) mdi-open-in-new
        v-list-item(@click="inviteAFriend()")
            v-icon(left) mdi-account-plus
            v-list-item-title {{ $t('Invite_a_friend') }}
        v-divider
        v-list-item(@click="logout()")
            v-icon(left) mdi-logout
            v-list-item-title {{$t('Log_out')}}
</template>

<script>
import { mapMutations } from 'vuex';
import Cookies from 'js-cookie';

export default {
    name: 'UserSettingsPopupWindow',
    computed: {
        user() {
            return JSON.parse(localStorage.getItem('user'))
        }
    },
    methods: {
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows',
            'setShowUserSettings',
            'setShowUserInviteFriend',
            'setShowUserAccount',
            'setUserSubscribed',
            'setUserCancelSubscribed'
        ]),
        settings() {
            this.setShowUserSettings(true);
        },
        signUp() {
            this.setRegisterType('signup');
            this.setRegisterWindows(true);
        },
        login() {
            this.setRegisterType('login');
            this.setRegisterWindows(true);
        },
        // account() {
        //     const tempUser = JSON.parse(localStorage.getItem('user'));

        //     if (tempUser.subscription_id !== null) {
        //         console.log('yes');
        //         this.setUserSubscribed(true);
        //         this.setUserCancelSubscribed(false);
        //     } else {
        //         console.log('no');
        //         this.setUserSubscribed(false);
        //         this.setUserCancelSubscribed(true);
        //     }

        //     this.setShowUserAccount(true);
        // },
        goToHelp() {
            window.open('https://intercom.help/edgerfinance/sv', '_blank');

            // const tempUser = JSON.parse(localStorage.getItem('user'));
            // const tempSettings = JSON.parse(tempUser.settings);
            // const language = tempSettings.language;

            // console.log(language);

            // if(language === "en") {
            //     window.open('https://intercom.help/tradersalloy/en/', '_blank');
            // } else if(language === "se") {
            //   const redirectWindow = window.open('https://intercom.help/tradersalloy/sv/','_blank');
            //   redirectWindow.location;
            // }
        },
        inviteAFriend() {
            this.setShowUserInviteFriend(true);
        },
        logout() {
            if(localStorage.getItem('visitorLanguage') === null) {
                localStorage.setItem('visitorLanguage', 'en');
            }

            localStorage.removeItem('user');
            Cookies.remove('user');

            window.location.href = "/";
        }
    }
}
</script>

<style scoped>

.v-list {
    padding: 0;
}

.v-list--dense .v-list-item {
    min-height: 50px;
}

.v-list--dense .v-list-item .v-list-item__title {
    font-size: 13px;
    font-weight: 400;
    line-height: normal;
}

.hide-element {
    visibility: hidden;
}
</style>
